import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, convertToParamMap} from '@angular/router';
import {OrderListResponse} from './order-list-response';
import {RequestExecutor} from '../../../util/request-executor';

@Injectable()
export class OrderAssignListResolver {
  constructor(private request: RequestExecutor) {
  }

  resolve(route: ActivatedRouteSnapshot): Promise<OrderListResponse> {
    const params = convertToParamMap(route.queryParams);

    const page = params.has('page') ? params.get('page') : 1;
    const pageSize = params.has('pageSize') ? +params.get('pageSize') : 20;

    let offset = 0;

    if (page != null) {
      offset = pageSize * (+page - 1);
    }

    const parameters = {
      offset: offset,
      count: pageSize,
      sortBy: params.get('sortBy'),
      sortDirection: params.get('sortDirection'),
      status: 'Started',
      includeAssignmentAndShipments: false
    };

    return this.request.get('/orders', parameters);
  }
}
